import script from "./MainMenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenuView.vue?vue&type=script&setup=true&lang=js"

import "./MainMenuView.vue?vue&type=style&index=0&id=11907c3a&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11907c3a"]])

export default __exports__